/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React, { ReactNode } from 'react'

import AssetTableCell from './AssetTableCell'
import { convertSetpoint, getVspColMeta } from './utils'

import { TemperatureUnit } from '../types'

type VspColProps = {
  value: number
  reeferInterfaceTypeId: number
  virtualSetpointAccessTypeId: number | undefined
  temperatureUnit?: TemperatureUnit
}

const VspCol: React.FC<VspColProps> = ({
  value,
  temperatureUnit = 'Metric',
  virtualSetpointAccessTypeId,
  reeferInterfaceTypeId,
}) => {
  const { displayBlank } = getVspColMeta(virtualSetpointAccessTypeId, reeferInterfaceTypeId, value)

  let displayValue: ReactNode = <div className="h-4 w-full flex"></div>
  if (!displayBlank) {
    displayValue = convertSetpoint(value, temperatureUnit)
  }

  return <AssetTableCell>{displayValue}</AssetTableCell>
}

export default VspCol
